var render, staticRenderFns
import script from "./MdButton.vue?vue&type=script&lang=js"
export * from "./MdButton.vue?vue&type=script&lang=js"
import style0 from "./MdButton.vue?vue&type=style&index=0&id=e43dbaa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports